module.exports = __webpack_public_path__ + "static/media/010.2300abf9.jpg";